<template>
	<div class="app-page flex-column" :class="{'s-bg': gradientBackground}">
		<div v-if="$scopedSlots.head" class="m-head">
			<slot name="head"></slot>
		</div>

		<div class="m-body flex-grow-auto" :class="{'flex-column': enableFlex}">
			<slot></slot>
			<div v-if="$scopedSlots.button" class="m-button-place"></div>
		</div>

		<div class="m-fixed-button">
			<div v-if="scanButton && scanAuth" class="item flex-center" @click="scanHandle">
				<i class="tf">&#xe62c;</i>
			</div>

			<div v-if="createButton" class="item flex-center" @click="$emit('create')">
				<i class="tf">&#xe727;</i>
			</div>
		</div>

		<div v-if="$scopedSlots.button" class="m-button flex-center">
			<slot name="button"></slot>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'

	export default {
		name: 'page',

		props: {
			enableFlex: Boolean,
			createButton: Boolean,
			scanButton: Boolean,
			gradientBackground: Boolean
		},

		data() {
			return {
				workbenchState: false
			}
		},

		computed: {
			...mapGetters(['scanAuth'])
		},

		methods: {
			scanHandle() {
				this.scanCode({
					success: data => {
						this.$emit('scan', data);
					}
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.app-page {
		position: relative;
		min-height: 100vh;
		min-height: 100dvh;

		&.s-bg {
			background: linear-gradient(180deg, #00A1E9, #F5F5F5 8rem);
		}

		.m-fixed-button {
			position: fixed;
			right: .24rem;
			bottom: calc(2rem + var(--safe-area));

			.item {
				box-sizing: border-box;
				width: .96rem;
				height: .96rem;
				border: .04rem solid #fff;
				border-radius: 100%;
				font-size: .44rem;
				color: #fff;
				background: var(--color-main);
				box-shadow: 0 .04rem .1rem .02rem rgba(40,50,75,.2);

				&:nth-child(n+2) {
					margin-top: .2rem;
				}
			}
		}

		.m-button {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			height: 1.2rem;
			border-top: .02rem solid #eee;
			padding: 0 .32rem var(--safe-area);
			background: #fff;

			&-place {
				height: 1.2rem;
				padding-bottom: var(--safe-area);
			}

			>>> .c-button {
				flex-grow: 1;
				width: 0;

				&:nth-child(n+2) {
					margin-left: .3rem;
				}
			}
		}
	}
</style>
